import { render, staticRenderFns } from "./DeleteIncome.vue?vue&type=template&id=67e408e6&scoped=true"
import script from "./DeleteIncome.vue?vue&type=script&lang=js"
export * from "./DeleteIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e408e6",
  null
  
)

export default component.exports